// assets/yotpo-ajax-simple.js
(function () {
  'use strict';

  if (window.__yotpoAjaxSimpleLoaded) return;
  window.__yotpoAjaxSimpleLoaded = true;

  const WRAPPER_SELECTOR = '.js-yotpo-stars';
  const INSTANCE_SELECTOR = '.yotpo-widget-instance, .yotpo.bottomLine';

  function reinitYotpo() {
    console.log('[Yotpo] Re-init requested');

    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      console.log('[Yotpo] yotpoWidgetsContainer.initWidgets()');
      window.yotpoWidgetsContainer.initWidgets();
      return true;
    }

    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      console.log('[Yotpo] yotpo.initWidgets()');
      window.yotpo.initWidgets();
      return true;
    }

    if (window.Yotpo && window.yotpo) {
      try {
        console.log('[Yotpo] new Yotpo.API(window.yotpo).refreshWidgets()');
        const api = new window.Yotpo.API(window.yotpo);
        api.refreshWidgets();
        return true;
      } catch (e) {}
    }

    console.warn('[Yotpo] No init method found');
    return false;
  }

  function markLoading(scope, isLoading) {
    const root = scope || document;
    root.querySelectorAll(WRAPPER_SELECTOR).forEach((w) => {
      if (isLoading) {
        w.classList.add('is-yotpo-loading');
        w.classList.remove('is-yotpo-hydrated'); // Show skeleton while loading
      } else {
        w.classList.remove('is-yotpo-loading');
      }
    });
  }

  function instanceHasStarsOrText(inst) {
    if (!inst) return false;

    // v3 widget
    if (inst.matches('.yotpo-widget-instance')) {
      if (inst.getAttribute('data-yotpo-element-loaded') === 'true') return true;
    }

    // legacy bottomLine commonly injects wrapper
    const display = inst.querySelector('.yotpo-display-wrapper');
    if (display && display.querySelector('.yotpo-stars, svg, a, button')) return true;

    // any injected children / content
    if (inst.children && inst.children.length) return true;
    if ((inst.textContent || '').trim().length) return true;

    return false;
  }

  function tryHydrate(scope) {
    const root = scope || document;
    const wrappers = root.querySelectorAll(WRAPPER_SELECTOR);
    if (!wrappers.length) return 0;

    let hydrated = 0;

    wrappers.forEach((w) => {
      if (w.classList.contains('is-yotpo-hydrated')) return;

      const inst = w.querySelector(INSTANCE_SELECTOR);
      if (instanceHasStarsOrText(inst)) {
        w.classList.remove('is-yotpo-loading');
        w.classList.add('is-yotpo-hydrated');
        hydrated += 1;
      }
    });

    return hydrated;
  }

  // Track running instances to prevent duplicates
  const runningInstances = new WeakMap();
  
  function run(scope, label) {
    // Skip if already running for this scope
    if (runningInstances.has(scope)) {
      console.log(`[Yotpo] Run: ${label} - SKIPPED (already running)`);
      return;
    }

    console.log(`[Yotpo] Run: ${label}`);

    // Mark this scope as running
    runningInstances.set(scope, true);

    // Only mark as loading if widgets aren't already hydrated
    const root = scope || document;
    const hasUnhydrated = root.querySelectorAll(`${WRAPPER_SELECTOR}:not(.is-yotpo-hydrated)`).length > 0;
    if (hasUnhydrated) {
      markLoading(scope, true);
    }

    reinitYotpo();

    // POLL (reliable) instead of MutationObserver (fragile w/ 3rd-party swaps)
    const start = Date.now();
    const maxMs = 6000;
    const tickMs = 200;

    const t = setInterval(() => {
      const count = tryHydrate(scope);
      if (count) console.log(`[Yotpo] Hydrated wrappers: ${count}`);

      // stop when done OR timed out
      const elapsed = Date.now() - start;
      if (elapsed > maxMs) {
        clearInterval(t);
        // Don't shimmer forever
        markLoading(scope, false);
        runningInstances.delete(scope);
        console.warn('[Yotpo] Poll timeout — stopping skeleton state');
      } else {
        // Check if all widgets are hydrated
        const allHydrated = root.querySelectorAll(`${WRAPPER_SELECTOR}:not(.is-yotpo-hydrated)`).length === 0;
        if (allHydrated) {
          clearInterval(t);
          markLoading(scope, false);
          runningInstances.delete(scope);
          console.log(`[Yotpo] All widgets hydrated for: ${label}`);
          return;
        }
        
        // If nothing is hydrating yet, lightly poke Yotpo once more around ~1s
        if (elapsed > 1000 && elapsed < 1200) reinitYotpo();
      }
    }, tickMs);
  }

  // Debounce Yotpo initialization to prevent rapid re-initializations
  const initTimeouts = new Map();
  const INIT_DEBOUNCE_MS = 500; // Wait 500ms after last event before initializing (longer to prevent flicker)
  const lastInitTime = new Map(); // Track when we last initialized each scope
  const MIN_TIME_BETWEEN_INITS = 1000; // Minimum 1 second between initializations for same scope

  // Helper to run Yotpo initialization with debouncing and rate limiting
  function handleNostoUpdate(ids, source) {
    // Clear existing timeout for this source
    if (initTimeouts.has(source)) {
      clearTimeout(initTimeouts.get(source));
    }

    // Set new timeout
    const timeoutId = setTimeout(() => {
      initTimeouts.delete(source);
      
      if (!ids || !ids.length) {
        // Check if we recently initialized the document scope
        const lastInit = lastInitTime.get(document);
        const timeSinceLastInit = lastInit ? Date.now() - lastInit : Infinity;
        
        if (timeSinceLastInit < MIN_TIME_BETWEEN_INITS) {
          console.log(`[Yotpo] Skipping ${source} (no ids) - too soon after last init (${Math.round(timeSinceLastInit)}ms ago)`);
          return;
        }
        
        lastInitTime.set(document, Date.now());
        run(document, `${source} (no ids)`);
        return;
      }

      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          // Check if we recently initialized this placement
          const lastInit = lastInitTime.get(el);
          const timeSinceLastInit = lastInit ? Date.now() - lastInit : Infinity;
          
          if (timeSinceLastInit < MIN_TIME_BETWEEN_INITS) {
            console.log(`[Yotpo] Skipping ${source} placement ${id} - too soon after last init (${Math.round(timeSinceLastInit)}ms ago)`);
            return;
          }
          
          lastInitTime.set(el, Date.now());
          run(el, `${source} placement ${id}`);
        }
      });
    }, INIT_DEBOUNCE_MS);

    initTimeouts.set(source, timeoutId);
  }

  document.addEventListener('DOMContentLoaded', () => {
    run(document, 'DOMContentLoaded');
  });

  // Listen to custom nosto:postrender event (dispatched by nosto-integration.js)
  document.addEventListener('nosto:postrender', (e) => {
    console.log('[Yotpo] nosto:postrender', e.detail);
    const ids = e.detail?.placements || [];
    handleNostoUpdate(ids, 'nosto:postrender');
  });

  // Also listen directly to Nosto API events as backup (more reliable)
  // This ensures Yotpo initializes even if nosto-integration.js hasn't loaded yet
  if (typeof window.nostojs === 'function') {
    window.nostojs((api) => {
      // taggingsent fires after recommendations are rendered (works in all modes)
      api.listen('taggingsent', (response) => {
        console.log('[Yotpo] Nosto taggingsent', response);
        const filled = Array.isArray(response?.filledElements) ? response.filledElements : [];
        handleNostoUpdate(filled, 'Nosto taggingsent');
      });

      // postrender only works in HTML response mode (backup)
      api.listen('postrender', (event) => {
        console.log('[Yotpo] Nosto postrender', event);
        const filled = Array.isArray(event?.filledElements) ? event.filledElements : [];
        handleNostoUpdate(filled, 'Nosto postrender');
      });
    });
  } else {
    // Wait for nostojs to be available
    let nostoCheckAttempts = 0;
    const checkNosto = setInterval(() => {
      nostoCheckAttempts++;
      if (typeof window.nostojs === 'function') {
        clearInterval(checkNosto);
        window.nostojs((api) => {
          api.listen('taggingsent', (response) => {
            console.log('[Yotpo] Nosto taggingsent', response);
            const filled = Array.isArray(response?.filledElements) ? response.filledElements : [];
            handleNostoUpdate(filled, 'Nosto taggingsent');
          });

          api.listen('postrender', (event) => {
            console.log('[Yotpo] Nosto postrender', event);
            const filled = Array.isArray(event?.filledElements) ? event.filledElements : [];
            handleNostoUpdate(filled, 'Nosto postrender');
          });
        });
      } else if (nostoCheckAttempts >= 40) {
        clearInterval(checkNosto);
      }
    }, 250);
  }

  document.addEventListener('yotpo:refresh', () => {
    run(document, 'yotpo:refresh');
  });
})();